import { render, staticRenderFns } from "./DefaultHeaderDropdown.vue?vue&type=template&id=488ff7b9&scoped=true&"
import script from "./DefaultHeaderDropdown.vue?vue&type=script&lang=js&"
export * from "./DefaultHeaderDropdown.vue?vue&type=script&lang=js&"
import style0 from "./DefaultHeaderDropdown.vue?vue&type=style&index=0&id=488ff7b9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "488ff7b9",
  null
  
)

export default component.exports